module.exports = __webpack_public_path__ + "img/img_onlo_phone.885be88a.svg";